import React from "react";
import {useTranslation} from "react-i18next";
import SpaceBetween from "@awsui/components-react/space-between";
import Button from "@awsui/components-react/button";
import NavigationBar from "components/NavigationBar";
import Container from "@awsui/components-react/container";
import Header from "@awsui/components-react/header";

const NotFoundPage: React.FC = () => {
    const {t} = useTranslation("notFound");
    return (
        <SpaceBetween size="l">
            <NavigationBar />
            <Container
                variant="default"
                header={
                    <Header variant="h2">{t("title")}</Header>
                }
            >
                <Button
                    variant={"primary"}
                    href={"/"}
                >
                    {t("backToHome")}
                </Button>
            </Container>
        </SpaceBetween>
    );
};

export default NotFoundPage;
